import AccountPassword from "./AccountPassword.vue";
export default AccountPassword;
